var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "book-debts" },
    [
      _vm.items.length
        ? _c("table", { staticClass: "mx-auto" }, [
            _c(
              "tbody",
              _vm._l(_vm.items, function(item) {
                return _c("tr", [
                  _c("td", { staticClass: "text-truncate text-right" }, [
                    _vm._v(_vm._s(item.debtor.name))
                  ]),
                  _vm._v(" "),
                  _c("td", {
                    staticClass: "text-truncate",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$formatMessage("debts_owes", {
                          name: item.creditor.name
                        })
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("format-currency")(
                          item.amount,
                          _vm.book.currency
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.payButton
                    ? _c(
                        "td",
                        [
                          _c("icon-button", {
                            attrs: {
                              name: "tick",
                              title: _vm.$formatMessage("debt_payback_tooltip"),
                              disabled: _vm.saving
                            },
                            on: {
                              click: function($event) {
                                _vm.pay(item)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              })
            ),
            _vm._v(" "),
            _c("tfoot", [
              _c("tr", [
                _c("td", { attrs: { colspan: "3" } }, [
                  _c("small", [
                    _vm._v(
                      _vm._s(
                        _vm.$formatMessage("debts_when", {
                          date: _vm.$formatDate(_vm.book.mtime)
                        })
                      )
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09a8970e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09a8970e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/book-debts.vue
// module id = fkpN
// module chunks = 3